/**
 * Dispatch and delivery estimate (snippets/cc-delivery-estimate.liquid).
 *
 * The rule, using only promises the site already makes:
 *   dispatched by   = the Nth working day after today (N = "dispatch within" setting, 5),
 *   usually with you = the next working day after that (Tracked 24's "next working day").
 * Working days are Monday to Friday, minus the dates listed in Theme settings (UK bank
 * holidays for England and Wales, plus any days Jane adds). "Today" is today in London,
 * whatever the visitor's clock says.
 *
 * In the order form it also watches the sail date:
 *   sail date on or before the delivery date -> "may not arrive in time" note,
 *   sail date within the "sailing soon" days  -> "choose Special Delivery" note.
 */
const DAY = 86400000;

const londonToday = () => {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  const get = (type) => Number(parts.find((p) => p.type === type).value);
  return Date.UTC(get('year'), get('month') - 1, get('day'));
};
const iso = (t) => new Date(t).toISOString().slice(0, 10);
const nice = (t) => new Date(t).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });

const workingDayAfter = (from, count, closed) => {
  let t = from;
  let n = 0;
  while (n < count) {
    t += DAY;
    const dow = new Date(t).getUTCDay();
    if (dow !== 0 && dow !== 6 && !closed.has(iso(t))) n += 1;
  }
  return t;
};

const escapeHtml = (s) => s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  const closed = new Set((root.dataset.noDispatch || '').match(/\d{4}-\d{2}-\d{2}/g) || []);
  const dispatchDays = Math.max(1, Number(root.dataset.dispatchDays) || 5);
  const soonDays = Math.max(0, Number(root.dataset.soonDays) || 10);
  const today = londonToday();
  const dispatchBy = workingDayAfter(today, dispatchDays, closed);
  const deliveryBy = workingDayAfter(dispatchBy, 1, closed);

  const text = root.querySelector('[data-eta-text]');
  if (text) {
    text.innerHTML = escapeHtml(text.dataset.template || '')
      .replace('[dispatch]', `<strong>${nice(dispatchBy)}</strong>`)
      .replace('[delivery]', `<strong>${nice(deliveryBy)}</strong>`);
  }
  root.hidden = false;

  if (!root.hasAttribute('data-watch-sail-date')) return;
  const form = root.closest('form') || root.parentElement;
  const date = form?.querySelector('input[type="date"]');
  const soon = root.querySelector('[data-eta-soon]');
  const late = root.querySelector('[data-eta-late]');
  if (!date) return;
  const update = () => {
    const [y, m, d] = (date.value || '').split('-').map(Number);
    const sail = y ? Date.UTC(y, m - 1, d) : null;
    const isLate = sail !== null && sail <= deliveryBy;
    const isSoon = sail !== null && !isLate && sail - today <= soonDays * DAY;
    if (late) late.hidden = !isLate;
    if (soon) soon.hidden = !isSoon;
  };
  date.addEventListener('input', update);
  date.addEventListener('change', update);
  update();
}

const run = () => document.querySelectorAll('[data-cc-eta]').forEach(init);
run();
document.addEventListener('DOMContentLoaded', run);
